import { ListingImage, ListingImageUpdate_Input } from 'graphql/generated';

const storageLocation = 'https://wyndscreenstoragedev.blob.core.windows.net/images';

const getPrimaryImageLocation = (images: ListingImage[] | ListingImageUpdate_Input[]) => {
  for (const image of images) if (image.primary) return getLocation(image);
};

function getLocation(image: ListingImage | ListingImageUpdate_Input): string {
  if (!image.external) return `${storageLocation}/${image.location}`;
  else return image.location;
}

// function toListingImageUpdate(image: ListingImage): ListingImage_Update;
// function toListingImageUpdate(images: ListingImage[]): ListingImage_Update[];
// function toListingImageUpdate(param1: ListingImage | ListingImage[]): ListingImage_Update | ListingImage_Update[] {
//   if (Array.isArray(param1)) return param1.map(x => toListingImageUpdate(x));

//   const updateImage: ListingImage_Update = {
//     id: param1.id,
//     primary: param1.primary,
//     location: param1.external ? param1.location : `${storageLocation}/${param1.location}`,
//     order: param1.order,
//   };
//   return updateImage;
// }

export const imageHelper = {
  getPrimaryImageLocation,
  getLocation,
};
